var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectManagementWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 7.50009C1.66663 4.27509 4.27497 1.66675 7.49997 1.66675L6.62497 3.12509",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.50009V3.59175C18.3333 3.82509 18.15 4.00842 17.9167 4.00842H10.4167C10.1833 4.00842 10 3.82509 10 3.59175V3.50009C10 2.03342 10.3667 1.66675 11.85 1.66675H16.4833C17.9667 1.66675 18.3333 2.03342 18.3333 3.50009Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 4.84155C10.1833 4.84155 10 5.02488 10 5.25822V6.09155V6.91655C10 8.38322 10.3667 8.74988 11.85 8.74988H16.4833C17.9667 8.74988 18.3333 8.38322 18.3333 6.91655V6.09155V5.25822C18.3333 5.02488 18.15 4.84155 17.9167 4.84155H10.4167Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 13.0833V13.175C9.99996 13.4083 9.81663 13.5917 9.5833 13.5917H2.0833C1.84997 13.5917 1.66663 13.4083 1.66663 13.175V13.0833C1.66663 11.6167 2.0333 11.25 3.51663 11.25H8.14996C9.6333 11.25 9.99996 11.6167 9.99996 13.0833Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0833 14.425C1.84997 14.425 1.66663 14.6083 1.66663 14.8417V15.675V16.5C1.66663 17.9667 2.0333 18.3333 3.51663 18.3333H8.14996C9.6333 18.3333 9.99996 17.9667 9.99996 16.5V15.675V14.8417C9.99996 14.6083 9.81663 14.425 9.5833 14.425H2.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagementWhiteIcon);
export default __webpack_public_path__ + "static/media/project-management-white-icon.fd0cfaac09fe3ab26f884b7feb33aa51.svg";
export { ForwardRef as ReactComponent };